import React from "react";
import image_1 from "../../images/smart-homes/Picture5-2.webp";

const mechanicalElectrical = [
  {
    id: 1,
    content: "IP Surveillance System",
  },
  {
    id: 2,
    content: "Multi Zone Sound System",
  },
  {
    id: 3,
    content: "WIFI Coverage",
  },
  {
    id: 4,
    content: "Smart Door Lock",
  },
  {
    id: 5,
    content: "Smart TV",
  },
  {
    id: 6,
    content: "Intruder System",
  },
  {
    id: 7,
    content: "Standalone Access Control",
  },
];

const MechanicalMlectrical = () => {
  return (
    <section className="pt-7 pb-7 bg-ghost-white" id="mechanical-&-electrical">
      <div className="me-13 ms-13">
        <div className="row">
          <div className="col-lg-6 col-xl-6 d-flex align-items-end pb-4">
            <img src={image_1} className="img-fluid rounded" alt="" />
          </div>
          <div className="col-lg-6 col-xl-6 my-auto ps-3 ps-md-5 py-5 py-lg-0">
            <h1 className="plex-sans fs-56 lh-64 mb-5">
              Mechanical <span className="text-orange-ryb">&</span> Electrical
            </h1>
            <div className="">
              {mechanicalElectrical.map((data, index) => (
                <div className="row mb-lg-4" key={data?.id}>
                  <h2
                    className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4 card-design-2"
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "50%",
                      lineHeight: "40px",
                    }}
                  >
                    {index + 1}
                  </h2>
                  <div className="col-10 my-auto">
                    <h3 className="fs-18 gilroy-bold">{data.content}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MechanicalMlectrical;
